import { render, staticRenderFns } from "./WriterAvatar.vue?vue&type=template&id=ab27f47c&scoped=true&"
import script from "./WriterAvatar.vue?vue&type=script&lang=js&"
export * from "./WriterAvatar.vue?vue&type=script&lang=js&"
import style0 from "./WriterAvatar.vue?vue&type=style&index=0&id=ab27f47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab27f47c",
  null
  
)

export default component.exports